import template from './FeedbackModalView.html';
import controller from './FeedbackModalController';
export default (params) => {
    return {
        template,
        controller,
        controllerAs: '$ctrl',
        ...params,
        inputs: {
            ...params.inputs,
            body: params.body || '',
            buttons: params.buttons || {},
        },
    };
};
